import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, createCommentVNode as _createCommentVNode } from "vue"

import { computed, watch } from 'vue'
import { t } from '@/plugins/i18n'
import Tooltip from '@/components/common/Tooltip.vue'


export default /*#__PURE__*/_defineComponent({
  props: ['modelValue', 'data'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props



const all = [
  {
    value: '2',
    label: '印刷',
    labelJP: '印刷',
    tipOption: {
      img: 'http://theckbs-oss.theckbs.com/customer/header/at388p2.png',
      title: '示例'
    }
  },
  {
    value: '1',
    label: '织唛',
    labelJP: '刺繍',
    tipOption: {
      img: 'http://theckbs-oss.theckbs.com/customer/header/56pe8dk.png',
      title: '示例'
    }
  }
]
const tabs = computed(() => {
  return props.data.ingredientsMaterialsId === '3' ? all : all.slice(0, 1)
})
const value = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})
watch(tabs, () => {
  if (props.data.ingredientsMaterialsId !== '3') {
    emit('update:modelValue', '2')
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (__props.data.ingredientsId === '1')
    ? (_openBlock(), _createBlock(_component_el_radio_group, {
        key: 0,
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
        onChange: _cache[1] || (_cache[1] = (val) => emit('update:modelValue', val))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (r) => {
            return (_openBlock(), _createBlock(_component_el_radio, {
              key: r.value,
              label: r.value
            }, {
              default: _withCtx(() => [
                _createVNode(Tooltip, {
                  "tip-option": r.tipOption
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(r.labelJP ? r.labelJP : _unref(t)(r.label)), 1)
                  ]),
                  _: 2
                }, 1032, ["tip-option"])
              ]),
              _: 2
            }, 1032, ["label"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})